import React, { Component } from 'react'
import ConductsPV from './ConductsPV'
import AuthA from '../../store/actions/AuthA'
import QuarterA from '../../store/actions/QuarterA'
import Papa from 'papaparse'

import axios from 'axios'
import sortBy from 'lodash/sortBy'
import find from 'lodash/find'
import constantCase from 'constant-case'
import paramCase from 'param-case'
import {connect} from 'react-redux'
import { getQuarterDbField, isValidQuarter } from '../../utils/quarterUtils'

const _ = {
    sortBy: sortBy,
    find: find
}

const changeCase = {
  constantCase: constantCase,
  paramCase: paramCase
}

class ConductsPC extends Component {
  constructor(props) {
    super(props);
    this.state = {
      conducts: [],
      section: [],
      sectionSubject: [],
      sectionSubjectId: '',
      column: null,
      direction: null,
      sectionStudents: [],
      error: false,
      success: false,
      fileName: '',
      conductSheet: null,
      areConductsSaved: false,
      results: [],
      dirtyInput: false,
      open: false,
      created: [],
      checked: [],
      reviewed: [],
      subjects: []
    };
    this.getConducts = this.getConducts.bind(this);
    this.getSection = this.getSection.bind(this);
    this.getSectionStudents = this.getSectionStudents.bind(this);
    this.handleUpdateSectionSubjectDetails = this.handleUpdateSectionSubjectDetails.bind(this);
    this.handleSort = this.handleSort.bind(this);
    this.handleUploadFileChange = this.handleUploadFileChange.bind(this);
    this.handleFileChange = this.handleFileChange.bind(this);
    this.handleDataChange = this.handleDataChange.bind(this);
    this.handleDataSave = this.handleDataSave.bind(this);
  }

  getConducts(sectionSubjectId) {
    const { sectionStudents } = this.state;
    const quarter = this.props.currentQuarter;
    axios.get(process.env.REACT_APP_URL+'/conducts?filter[where][active]=true&filter[where][sectionSubjectId]='+sectionSubjectId)
    .then(response => {
      this.setState({ conducts: response.data}, () => {
        if (response.data.length !== 0) {
          sectionStudents.map((sectionStudent, key )=> {
            const studentName = sectionStudent.student.lastName +', '+sectionStudent.student.firstName;
            const studentVariable = changeCase.constantCase(studentName);
            const conduct = _.find(response.data, {
              sectionStudentId: sectionStudent.sectionStudentId
            });
            // Get conduct fields based on current quarter
            const quarterField = getQuarterDbField(parseInt(quarter), 'conducts');
            const quarterFieldBase = quarterField.replace('Quarter', 'Quarter');

            // Helper to convert 0 or null to empty string for display
            const displayValue = (val) => (val === null || val === undefined || val === 0) ? '' : val;

            this.setState({
              [studentVariable]: conduct != null ? displayValue(conduct[quarterField]) : '',
              [`${studentVariable}-1`]: conduct != null ? displayValue(conduct[`${quarterFieldBase}1`]) : '',
              [`${studentVariable}-2`]: conduct != null ? displayValue(conduct[`${quarterFieldBase}2`]) : '',
              [`${studentVariable}-3`]: conduct != null ? displayValue(conduct[`${quarterFieldBase}3`]) : '',
              [`${studentVariable}-4`]: conduct != null ? displayValue(conduct[`${quarterFieldBase}4`]) : '',
              [`${studentVariable}-5`]: conduct != null ? displayValue(conduct[`${quarterFieldBase}5`]) : '',
              areConductsSaved: true
            })
            return true;
          })
        } else {
          sectionStudents.map((sectionStudent, key )=> {
            const studentName = sectionStudent.student.lastName +', '+sectionStudent.student.firstName;
            const studentVariable = changeCase.constantCase(studentName);

            this.setState({
              [studentVariable]: '',
              [`${studentVariable}-1`]: '',
              [`${studentVariable}-2`]: '',
              [`${studentVariable}-3`]: '',
              [`${studentVariable}-4`]: '',
              [`${studentVariable}-5`]: '',
              areConductsSaved: false
            })

            return true;
          })
        }
      });
    });
  }

  getSection(sectionId) {
    axios.get(process.env.REACT_APP_URL+'/sections?filter[where][active]=true&filter[where][sectionId]='+sectionId)
    .then(response => {
      this.setState({ section: response.data});
    });
  }

  getSectionSubject = (sectionSubjectId) => {
    axios.get(process.env.REACT_APP_URL+'/sectionSubjects?filter[where][active]=true&filter[include]=subject&filter[include]=details&filter[where][sectionSubjectId]='+sectionSubjectId)
    .then(async(response) => {
      await this.getSectionSubjectDetailsForChecking();
      await this.getSectionSubjectDetailsForReview();
      await this.getSectionSubjectDetailsForApproval();
      await this.getSubjects();
      this.setState({ sectionSubject: response.data});
    });
  }

  getSectionSubjectDetailsForChecking = async() => {
    await axios.get(process.env.REACT_APP_URL+`/sectionSubjectDetails?filter[where][active]=true&filter[include]=sectionSubject&filter[where][status]=Created&filter[where][type]=conduct&filter[where][quarter]=${this.props.currentQuarter}`)
    .then(response => {
      this.setState({created: response.data})
    });
  }

  getSectionSubjectDetailsForReview = async() => {
    await axios.get(process.env.REACT_APP_URL+`/sectionSubjectDetails?filter[where][active]=true&filter[include]=sectionSubject&filter[where][status]=Checked&filter[where][type]=conduct&filter[where][quarter]=${this.props.currentQuarter}`)
    .then(response => {
      this.setState({checked: response.data})
    });
  }

  getSectionSubjectDetailsForApproval = async() => {
    await axios.get(process.env.REACT_APP_URL+`/sectionSubjectDetails?filter[where][active]=true&filter[include]=sectionSubject&filter[where][status]=Reviewed&filter[where][type]=conduct&filter[where][quarter]=${this.props.currentQuarter}`)
    .then(response => {
      this.setState({reviewed: response.data})
    });
  }

  getSubjects = async() => {
    // Add 2 second delay before fetching subjects
    await new Promise(resolve => setTimeout(resolve, 5000));

    await axios.get(process.env.REACT_APP_URL+'/subjects?filter[where][active]=true')
    .then(response => {
      this.setState({ subjects: response.data });
    });
  }

  getSectionStudents(sectionId) {
    axios.get(process.env.REACT_APP_URL+'/sectionStudents?filter[where][active]=true&filter[include]=student&filter[where][sectionId]='+sectionId)
    .then(response => {
      const sorted = _.sortBy(response.data, function(o){return [o.student.lastName, o.student.firstName]})
      this.setState({ sectionStudents: sorted }, () => {
        // this.handleSort('name')
        this.getConducts(this.state.sectionSubjectId);
      });
    });
  }

  handleUpdateSectionSubjectDetails(data, id) {
    const sectionSubjectDetail = _.find(this.state.sectionSubject[0].details, {
      quarter: this.props.currentQuarter,
      type: 'conduct'
    });

    if (this.state.conductSheet != null) {
      if (sectionSubjectDetail.status === 'To Do' || sectionSubjectDetail.status === 'Discarded') {
        let fileData = new FormData();
        fileData.append('filePath', this.state.conductSheet);
        if (this.state.conductSheet.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
          const uploadUrl = `${process.env.REACT_APP_URL}/containers/${process.env.REACT_APP_CONTAINER}/upload`;
          axios.request({
            method:'post',
            url:`${uploadUrl}`,
            data: fileData
          }).then(response => {
            console.log(response)
          }).catch(err => console.log(err));
        } else {
          alert('File extension must be xlsx. Please save your conduct sheet in xlsx format.')
          this.setState({open: false})
          return
        }
      }
    }

    const url = process.env.REACT_APP_URL+'/sectionSubjectDetails/'+id;
    axios
      .request({
        method: 'put',
        url: url,
        data: data
      })
      .then(response => {
        alert('The status of this subject was successfully updated.')
        this.setState({open: false}, this.getSectionSubject(this.state.sectionSubjectId))
      })
      .catch(err => console.log(err));


  }

  handleSort(clickedColumn) {
    const { column, sectionStudents, direction } = this.state
    if (column !== clickedColumn) {
      if(clickedColumn === 'name') {
        this.setState({
          column: clickedColumn,
          sectionStudents: _.sortBy(sectionStudents, function(o){return o.student.lastName}),
          direction: 'ascending',
        })
        return
      } else {
        this.setState({
          column: clickedColumn,
          sectionStudents: _.sortBy(sectionStudents, [clickedColumn]),
          direction: 'ascending',
        })
        return
      }
    }
    this.setState({
      sectionStudents: sectionStudents.reverse(),
      direction: direction === 'ascending' ? 'descending' : 'ascending',
    })
  }

  handleChange = (e, { name, value }) => {
    if (name.includes('-')) {
      const stateName = name.split('-');
      let total=0;
      const changedNumber = isNaN(parseInt(value)) || value === '' ? 0 : parseInt(value);

      for(let i = 1; i < 6; i++) {
        if(parseInt(stateName[1]) !== i) {
          const currentValue = this.state[`${stateName[0]}-${i}`];
          const numValue = isNaN(parseInt(currentValue)) || currentValue === '' ? 0 : parseInt(currentValue);
          total = parseInt(total) + numValue;
        }
      }
      total = parseInt(total) + changedNumber;
      this.setState({[stateName[0]]: total, [name]: value, dirtyInput: true})
    } else {
      this.setState({[name]: value, dirtyInput: true})
    }

  }

  handleApprovalOpen = () => {
    this.setState({
      open: true
    })
  }

  handleApprovalClose = () => this.setState({
    open: false
  })

  handleSubmit = () => {

    const {sectionStudents, sectionSubject} = this.state;
    const quarter = this.props.currentQuarter;

    // Validations
    let hasInvalidValue = sectionStudents.some((sectionStudent) => {
      const studentName = sectionStudent.student.lastName +', '+sectionStudent.student.firstName;
      const studentVariable = changeCase.constantCase(studentName);

      if(this.state[studentVariable] === undefined) {
        return true;
      }

      return parseInt(this.state[studentVariable],10) < 1 || parseInt(this.state[studentVariable],10) > 25 || this.state[studentVariable] === ''
    });

    if (hasInvalidValue) {
      this.setState({error: hasInvalidValue, success: false})
    } else {
      sectionStudents.map((sectionStudent, key )=> {
        const studentName = sectionStudent.student.lastName +', '+sectionStudent.student.firstName;
        const studentVariable = changeCase.constantCase(studentName);

        // Get quarter field using centralized utility
        const quarterLabel = getQuarterDbField(parseInt(quarter), 'conducts');
        const sectionSubjectId = sectionSubject[0].sectionSubjectId;
        const sectionStudentId = sectionStudent.sectionStudentId;

        // Convert empty strings to 0 for database storage
        const getValue = (val) => val === '' || val === undefined || val === null ? 0 : val;

        const data = {
          sectionStudentId: sectionStudentId,
          sectionSubjectId: sectionSubjectId,
          [quarterLabel]:  getValue(this.state[studentVariable]),
          [`${quarterLabel}1`]:  getValue(this.state[`${studentVariable}-1`]),
          [`${quarterLabel}2`]:  getValue(this.state[`${studentVariable}-2`]),
          [`${quarterLabel}3`]:  getValue(this.state[`${studentVariable}-3`]),
          [`${quarterLabel}4`]:  getValue(this.state[`${studentVariable}-4`]),
          [`${quarterLabel}5`]:  getValue(this.state[`${studentVariable}-5`])
        }

        const url = process.env.REACT_APP_URL+'/conducts/upsertWithWhere?where={"sectionSubjectId":"'+sectionSubjectId+'","sectionStudentId":"'+sectionStudentId+'"}';
        axios
          .request({
            method: 'post',
            url: url,
            data: data
          })
          .then(response => {
            console.log(response.data)
            this.getConducts(sectionSubjectId)
          })
          .catch(err => console.log(err));

        return true;
      })
      //Show next steps for the approval process
      this.setState({success: true, error: false, dirtyInput: false, open: true})
    }
  }

  handleUploadFileChange(conductSheet) {
    const { sectionSubject, section } = this.state;
    const quarter = this.props.currentQuarter;

    let fileName = `${changeCase.paramCase(sectionSubject[0].subject.name)}-${changeCase.paramCase(section[0].name)}-conducts-${quarter}.xlsx`;
    const newFileName = `2019-2020/${sectionSubject[0].subject.code}/${fileName}`;
    const file = new File([conductSheet], newFileName, { type: conductSheet.type });

    this.setState({conductSheet: file, fileName: fileName});
  }

  handleFileChange(file, sectionId) {
    const self = this;
    Papa.parse(file, {
      header: true,
      dynamicTyping: true,
      skipEmptyLines: true,
      complete: function(results) {
        self.handleDataChange(results, sectionId)
    	}
    });
  }

  handleDataChange(results) {
    // this.handleDataSave(results.data);
    this.setState({results: results.data})
    console.log('Parsing complete:', results);
  }

  handleDataSave() {
    const data = this.state.results;
    const { sectionSubject, sectionStudents } = this.state;
    const quarter = this.props.currentQuarter;
    let parsedStudent = {};

    // Get quarter field using centralized utility
    const quarterLabel = getQuarterDbField(quarter, 'conducts');

    const sectionSubjectId = sectionSubject[0].sectionSubjectId;

    for (let i = 0; i < data.length; i++) {

      // const firstName = data[i]['First Name'];
      // const lastName = data[i]['Last Name'];
      const studentNumber = data[i]['Student Number'];
      const criteria1 = data[i]['Criteria 1'];
      const criteria2 = data[i]['Criteria 2'];
      const criteria3 = data[i]['Criteria 3'];
      const criteria4 = data[i]['Criteria 4'];
      const criteria5 = data[i]['Criteria 5'];
      const conduct = data[i]['Total'];

      const student = _.find(sectionStudents, function(o) {
        return o.student.studentNumber === studentNumber
      });
      console.log(student)
      if (student != null) {
        parsedStudent = {
          sectionSubjectId: sectionSubject[0].sectionSubjectId,
          sectionStudentId: student.sectionStudentId,
          [`${quarterLabel}1`]: criteria1,
          [`${quarterLabel}2`]: criteria2,
          [`${quarterLabel}3`]: criteria3,
          [`${quarterLabel}4`]: criteria4,
          [`${quarterLabel}5`]: criteria5,
          [quarterLabel]: conduct
        }
      } else {
        alert('Error. Please contact your administrator for assistance.');
        return
      }
      const sectionStudentId = student.sectionStudentId;
      const url = process.env.REACT_APP_URL+'/conducts/upsertWithWhere?where={"sectionSubjectId":"'+sectionSubjectId+'","sectionStudentId":"'+sectionStudentId+'"}';
      axios
        .request({
          method: 'post',
          url: url,
          data: parsedStudent
        })
        .then(response => {
          console.log(response.data)
          if (i === data.length-1) {
            this.setState({success: true}, () => this.getConducts(sectionSubjectId));
          }
        })
        .catch(error => {
          console.log(error)
          if (error.response) {
            alert(`${error.response.data.error.message}`);
          } else if (error.request) {
            alert(error.request);
          } else {
            // Something happened in setting up the request that triggered an Error
            alert('Error. Please contact your administrator for assistance.');
          }
        });
    }
    alert('Conducts successfully added!')
  }

  componentDidMount() {
    this.props.authFn.getToken()
    this.props.onContentMount({title:'Conducts'});

    const sectionId = this.props.match.params.sectionId;
    const sectionSubjectId = this.props.match.params.sectionSubjectId;
    const params = new URLSearchParams(this.props.location.search);
    const quarter = params.get('quarter');
    
    // Update Redux quarter state if quarter is provided in URL
    if (quarter && isValidQuarter(parseInt(quarter))) {
      this.props.quarterActions.setCurrentQuarter(parseInt(quarter));
    }
    
    this.setState({sectionSubjectId: sectionSubjectId}, () => {
      this.getSectionStudents(sectionId);
      this.getSectionSubject(sectionSubjectId);
      this.getSection(sectionId);
    })

  }

  componentDidUpdate(prevProps) {
    const sectionId = this.props.match.params.sectionId;
    const sectionSubjectId = this.props.match.params.sectionSubjectId;
    const prevSectionId = prevProps.match.params.sectionId;
    const prevSectionSubjectId = prevProps.match.params.sectionSubjectId;
    const params = new URLSearchParams(this.props.location.search);
    const quarter = params.get('quarter');

    // Only update if route params actually changed
    const hasChanged = sectionId !== prevSectionId ||
                      sectionSubjectId !== prevSectionSubjectId ||
                      this.props.currentQuarter !== prevProps.currentQuarter;

    if (!hasChanged) {
      return; // Prevent duplicate API calls
    }

    // Update Redux quarter state if quarter is provided in URL
    if (quarter && isValidQuarter(parseInt(quarter))) {
      this.props.quarterActions.setCurrentQuarter(parseInt(quarter));
    }

    // Clear any existing timeout
    if (this.updateTimeout) {
      clearTimeout(this.updateTimeout);
    }

    // Add 1 second delay before making API calls
    this.updateTimeout = setTimeout(() => {
      this.setState({sectionSubjectId: sectionSubjectId}, () => {
        this.getSectionStudents(sectionId);
        this.getSectionSubject(sectionSubjectId);
        this.getSection(sectionId);
      });
    }, 1000);
  }

  render() {
    return (
      <ConductsPV
        auth={this.props.auth}
        username={this.props.username}
        userType={this.props.userType}
        userId={this.props.userId}
        column={this.state.column}
        direction={this.state.direction}
        section={this.state.section}
        sectionSubject={this.state.sectionSubject}
        sectionStudents={this.state.sectionStudents}
        error={this.state.error}
        success={this.state.success}
        quarter={this.props.currentQuarter}
        fileName={this.state.fileName}
        areConductsSaved={this.state.areConductsSaved}
        dirtyInput={this.state.dirtyInput}
        open={this.state.open}
        created={this.state.created}
        checked={this.state.checked}
        reviewed={this.state.reviewed}
        subjects={this.state.subjects}
        {...this.state}
        handleApprovalOpen={this.handleApprovalOpen}
        handleApprovalClose={this.handleApprovalClose}
        handleUpdateSectionSubjectDetails={this.handleUpdateSectionSubjectDetails}
        handleDataSave={this.handleDataSave}
        handleSort={this.handleSort}
        handleChange={this.handleChange}
        handleSubmit={this.handleSubmit}
        handleFileChange={this.handleFileChange}
        handleUploadFileChange={this.handleUploadFileChange}
      />
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    authFn: AuthA(dispatch),
    quarterActions: QuarterA(dispatch)
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.AuthR.auth,
    username: state.AuthR.username,
    userType: state.AuthR.userType,
    userId: state.AuthR.userId,
    currentQuarter: state.QuarterR.currentQuarter,
    schoolYearId: state.QuarterR.schoolYearId
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ConductsPC);
